// extracted by mini-css-extract-plugin
export default {"wrapper":"jmiQ15aVFJgOilIP81F0","btnWrap":"CfTQfdXi9MjJbDBOAVhp"};